









import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import buildTokenMixin from './TokenMixin';
import { VariableToken, Variables, TokenType } from './Types';

export default mixins(buildTokenMixin<VariableToken>()).extend({
    name: 'VariableToken',
    components: {
        EnumSelector: () => import('@/Shared/EnumSelector.vue'),
    },
    data() {
        return {
            i18nPrefix: 'admin.ticketTemplateBuilder.variableToken',
            Variables,
            TokenType,
        };
    },
    props: {
        token: {
            type: Object as () => VariableToken
        }
    },
});
